import { IconButton, TableCell, TableRow, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AppColors } from "resources/AppColors";
import { radioButtonOptions } from "./AddOrEditScheduledForm";

const ScheduledFormToDisplay = ({ form, handleShowEditModal, handleShowDeleteModal, canEditDelete, formNameValue, studyName }) => {

  const translatePriority = radioButtonOptions.find((option) => option.value === form.type)?.label || '-';

  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell align="left">
        <Typography variant='body'>{formNameValue}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{studyName}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{form.title ? form.title : '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{form.businessLabel ? form.businessLabel : '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{form.businessPackage ? form.businessPackage.name : '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{form.daysOpen ? form.daysOpen : '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{translatePriority}</Typography>
      </TableCell>
      <TableCell align="center" p={0}>
        {canEditDelete && handleShowEditModal &&
          <IconButton onClick={() => handleShowEditModal(form)} size="large">
            <EditIcon sx={{ fill: AppColors.PRIMARY }} />
          </IconButton>}
        {canEditDelete && handleShowDeleteModal &&
          <IconButton onClick={() => handleShowDeleteModal(form.id)} size="large">
            <DeleteIcon sx={{ fill: AppColors.PRIMARY }} />
          </IconButton>}
      </TableCell>
    </TableRow>
  );
}

export default ScheduledFormToDisplay

